import { PanelBarTemplate } from "../../../../../shared/expandable-panelbar/expandable-panelbar.component";
import { Injector } from "@angular/core";
import { RequestDetailService } from "../detail.service";
import { ToolingApprovalPanelbar } from "./tooling-approval.panelbar";

export class WorkApprovalMatrix extends PanelBarTemplate {
    private readonly detailService: RequestDetailService;

    constructor(private readonly injector: Injector) {
        super();
        this.title = 'Work Approval Matrix';
        this.iconClass = 'fa-pencil-square-o ';
        this.detailService = injector.get(RequestDetailService);
        this.canRefresh = false;
        this.id = this.title;
        this.expanded = true;
        this.detailService.workApprovalData
            .subscribe(data => {
                this.updateWorkApprovalPanelbar(data)
            });
    }


    refresh = () => this.detailService.refreshWorkApprovalMatrix();


    private updateWorkApprovalPanelbar(dataItem: any) {
        this.loading.next(true);
        if (!dataItem || typeof (dataItem) === typeof (true)) {
            this.loading.next(dataItem);
            return;
        }
        this.reset();
        this.approvalStatus.next(dataItem.OverAllStatus);

        if (dataItem && dataItem.ToolingParts) {
            dataItem.ToolingParts.forEach(pa => {
                pa.RequestId = dataItem.RequestId;
                const pb: ToolingApprovalPanelbar = new ToolingApprovalPanelbar(this.injector);
                pa.ParentEditDataItem = dataItem;
                pb.setApprovalData(pa);
                pb.setApprovalStatus(pa);
                pb.id = pa.PartId;
                const partType: string = (pa.IsPrimary ? 'Primary Part' : 'Impacted Part');
                const _title = `${partType} : ${pa.PartTitle}`;
                pb.iconStack = false;
                pb.iconClass = 'fa-wrench';
                pb.title = _title;
                this.addPanelBar(pb, pa.IsPrimary);
            });
        }
        this.loading.next(false);
    }



}
